import { useLocation } from 'react-router';

import { AUTOMATED_DOC_COLLECTION, EARLY_DOCS_COLLECTION } from '../../../../../../utilities/routing';
import { TimelineEarlyDocsIncodeComplete } from '../../../../vehicleProfiling/Timeline/TimelineEarlyDocs/TimelineEarlyDocsIncodeComplete/TimelineEarlyDocsIncodeComplete';
import { DOCUMENT_CAPTURE_ROUTE_NAMES } from '../../../DocumentCapture.helpers';
import { DocumentCaptureViewLayout } from '../../../DocumentCaptureView/DocumentCaptureView';

import { useEarlyDocsIncodeVerificationDocuments } from './hooks/useEarlyDocsIncodeVerificationDocuments';
import { useIncodeVerificationSession } from './hooks/useIncodeVerificationSession';
import { IncodeSDKPage } from './IncodeSDKPage';
import { IncodeCaptureComplete } from './steps';

import styles from './IncodeGlobal.scss';

const IncodeSDKEarlyDocs = () => {
  const { incodeSession } = useEarlyDocsIncodeVerificationDocuments();

  return (
    <div className={styles.incodeComponent}>
      <DocumentCaptureViewLayout>
        <IncodeSDKPage
          incodeSession={incodeSession}
          renderCompleteComponent={() => (
            <TimelineEarlyDocsIncodeComplete />
          )}
          url={EARLY_DOCS_COLLECTION}
        />
      </DocumentCaptureViewLayout>
    </div>
  );
};

const IncodeSDKPostSale = () => {
  const { incodeSession } = useIncodeVerificationSession();

  return (
    <div className={styles.incodeComponent}>
      <IncodeSDKPage
        incodeSession={incodeSession}
        renderCompleteComponent={(incodeProps) => (
          <IncodeCaptureComplete {...incodeProps} />
        )}
        url={AUTOMATED_DOC_COLLECTION}
      />
    </div>
  );
};

export const IncodeSDKPageHOC = () => {
  const location = useLocation();
  const isPostSaleFlow = location.pathname.includes(DOCUMENT_CAPTURE_ROUTE_NAMES.AUTOMATED_DOCS_PAGE);

  return isPostSaleFlow ? <IncodeSDKPostSale /> : <IncodeSDKEarlyDocs />;
};
